class FacetDrawer extends Drawer {
    constructor() {
        super();
        const opener = document.querySelector('[data-filter-opener]');
        if (!opener) return
        this.setIconAccessibility(opener);
    }

    connectedCallback() {
        if (this.isDesktop) {
            this.openDetails();
        }
        subscribe(PUB_SUB_EVENTS.facetsUpdate, () => super.setListeners())
    }

    setActiveElement(element) {
        this.activeElement = element;
    }

    openDetails() {
        this.querySelectorAll('details.js-filter').forEach((detail) => {
            detail.setAttribute('open', 'true');
        });
    }


}

customElements.define('facet-drawer', FacetDrawer);
